import React, { useState } from "react";

interface FaqItem {
  q: string;
  a: string | React.ReactNode;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

export const FaqAccordion: React.FC<FaqAccordionProps> = ({ items }) => {
  const [open, setOpen] = useState(0);

  return (
    <div className="faq">
      {items.map((it, i) => (
        <div key={i} className={"faq__item" + (open === i ? " is-open" : "")}>
          <button
            className="faq__q"
            onClick={() => setOpen(open === i ? -1 : i)}
          >
            <span>{it.q}</span>
            <span className="faq__chev">
              <svg viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </span>
          </button>
          <div className="faq__a">{it.a}</div>
        </div>
      ))}
    </div>
  );
};
